'use client';

import { UiProvider } from '@portal/lib-ui';
import { LoginProvider } from '@/contexts/LoginContext';

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <UiProvider>
      <LoginProvider>{children}</LoginProvider>
    </UiProvider>
  );
}
